import { useEffect, useState } from "react";
import { VispsicologicasCreate } from "./VispsicologicasCreate";
import { useLoaderData, useParams } from "react-router-dom";

import * as APITRATAMIENTO from "../services/tratamientos";

export function VispsicologicasNew(props) {
  const vispsicologicas = useLoaderData();

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);
  const [permisoTemporalPsicohosp, setPermisoTemporalPsicohosp] = useState(false);
  console.log(permisoTemporalPsicohosp)


  // Set default valor for today date
  const todayDate = new Date().toISOString().replace(/T.*/,'').split('-').join('-');
  const currentDate = new Date();
  const currentTime = (currentDate.getHours()<10?'0':'') + currentDate.getHours() + ":" + (currentDate.getMinutes()<10?'0':'') + currentDate.getMinutes();

  // Set number of sesion based on number of items published
  let vispsicologicasLength = vispsicologicas.length;
  let currentSesion = vispsicologicasLength + 1;

  const [vispsicResp, setVispsicResp] = useState(props.especialistaFullName);
  const [vispsicFecha, setVispsicFecha] = useState(todayDate);
  const [vispsicHora, setVispsicHora] = useState(currentTime);
  const [vispsicObs, setVispsicObs] = useState("");
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  // Permiso temporal para Psicólogo
  useEffect(() => {
    const loadTratamientoData = async () => {
      // Obtener los datos del tratamiento
      const tratamiento = await APITRATAMIENTO.getTratamientoById(tratamientoId);

      // Verificar si el especialistaId está en meta.psicohosp
      const permiso = tratamiento.meta.psicohosp.some(
        (psicologo) => {
          return psicologo.value === props.especialistaId;
        }
      );
  
      // Guardar el resultado en el estado
      setPermisoTemporalPsicohosp(permiso);
    };
  
    loadTratamientoData();
  }, [tratamientoId, props.especialistaId]);

  const submitVispsicologicas = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      vispsicResp,
      vispsicFecha,
      vispsicHora,
      vispsicObs,
      tratamientoId,
      pacienteId
    );
    try {
      await VispsicologicasCreate(
        vispsicResp,
        vispsicFecha,
        vispsicHora,
        vispsicObs,
        tratamientoId,
        pacienteId
      ).then(
        (val) => {
          window.location.replace(
            `../visitas-psicologicas/${val.id}`
          );
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        <form id='formNewElement' onSubmit={submitVispsicologicas}>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='vispsicResp'>Responsable</label>
              <div className='control'>
                <input
                  className='input'
                  id='vispsicResp'
                  required
                  type='text'
                  value={vispsicResp}
                  onChange={(e) => setVispsicResp(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='vispsicFecha'>Fecha visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='vispsicFecha'
                  required
                  type='date'
                  value={vispsicFecha}
                  onChange={(e) => setVispsicFecha(e.target.value)}
                />
              </div>
            </div>
            {/* <div className='field'>
              <label htmlFor='vispsicHora'>Hora de Visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='vispsicHora'
                  required
                  type='time'
                  value={vispsicHora}
                  onChange={(e) => setVispsicHora(e.target.value)}
                />
              </div>
            </div> */}
          </div>
          <div className='field'>
            <label htmlFor='vispsicObs'>Observaciones</label>
            <div className='control'>
              <textarea
                className='textarea'
                name='vispsicObs'
                id='vispsicObs'
                value={vispsicObs}
                onChange={(e) => setVispsicObs(e.target.value)}
              ></textarea>
            </div>
          </div>
        </form>
      </div>
      <div id='actions'>
      {(props.userRole.includes('administrador') || props.userRole.includes('psicologia-hospital') || permisoTemporalPsicohosp) && (
        <button 
        className='button is-link' 
        form='formNewElement' 
        type='submit'
        disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
        </button>
      )}
      </div>
    </>
  );
}
